/**
 * Wenzel TCG – quick-add fly-to-cart (product thumbnail)
 * - Homepage rotator / marked forms: [data-wzr-fly-add], .wzr-fly-add, .wzr-rot__form
 * - Collection / catalog cards: injects ADD under the price; click AJAX-adds + flies a mini product image
 * - Flight is clamped to the viewport every frame (never clips off-screen)
 * - Fly image: variant featured image when that variant is added; otherwise the FIRST product photo on the card
 * - Fallback (no image): purple branded orb — not a Poké Ball
 * - "Maximum quantity reached" toast on the qty stepper (+) and on cart-add max errors
 * - Multi-variant products: compact option pills / dropdown on the card quick add (variant-aware price, image, max)
 * - Compact "Empty cart" control at the TOP of the cart page / drawer / notification (branded modal -> /cart/clear.js)
 */
(function () {
  'use strict';
  if (window.__wzrCartFly) return;
  window.__wzrCartFly = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FLY_MS = 620;
  var BOUNCE_MS = 620;
  var busy = false;
  var productCache = Object.create(null);

  function headerCartIcon() {
    return (
      document.getElementById('cart-icon-bubble') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('a[href$="/cart"]')
    );
  }

  function cartIcon() {
    var floating = document.getElementById('wz-float-cart');
    if (floating && floating.classList.contains('is-visible')) return floating;
    return headerCartIcon();
  }

  function routesRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function addUrl() {
    return routesRoot().replace(/\/?$/, '/') + 'cart/add.js';
  }

  function cartUrl() {
    return routesRoot().replace(/\/?$/, '/') + 'cart.js';
  }

  function updateCartCount(itemCount) {
    // Header icon only: the floating cart has its own [data-wz-float-count] badge.
    // (Using cartIcon() here appended a 2nd .cart-count-bubble to the floating cart = double badge.)
    var stray = document.querySelectorAll('#wz-float-cart .cart-count-bubble');
    for (var si = 0; si < stray.length; si++) stray[si].remove();
    var icon = headerCartIcon();
    if (!icon) return;
    var n = parseInt(itemCount, 10) || 0;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (n <= 0) {
      if (bubble) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      icon.appendChild(bubble);
    }
    var shown = n < 100 ? String(n) : '99+';
    bubble.innerHTML =
      '<span aria-hidden="true">' +
      shown +
      '</span><span class="visually-hidden">' +
      n +
      (n === 1 ? ' item' : ' items') +
      '</span>';
  }

  function bounceCart(target) {
    var icon = target || cartIcon();
    if (!icon) return;
    icon.classList.remove('wz-cart--bounce');
    void icon.offsetWidth;
    icon.classList.add('wz-cart--bounce');
    window.setTimeout(function () {
      icon.classList.remove('wz-cart--bounce');
    }, BOUNCE_MS);
  }

  /* Purple branded orb fallback when no product image is available (NOT a Poké Ball). */
  function brandOrbSvg() {
    var gid = 'wzOrbShine' + Math.floor(Math.random() * 1e9);
    return (
      '<svg class="wz-fly-thumb__orb" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true" focusable="false">' +
      '<defs><radialGradient id="' + gid + '" cx="34%" cy="30%" r="60%">' +
      '<stop offset="0%" stop-color="#f0d0ff" stop-opacity=".75"/>' +
      '<stop offset="45%" stop-color="#9b4dff" stop-opacity=".35"/>' +
      '<stop offset="100%" stop-color="#2a0a45" stop-opacity="0"/>' +
      '</radialGradient></defs>' +
      '<circle cx="32" cy="32" r="30" fill="#1a0a2e"/>' +
      '<circle cx="32" cy="32" r="26" fill="#6b2fb5"/>' +
      '<circle cx="32" cy="32" r="18" fill="#9b4dff"/>' +
      '<circle cx="32" cy="32" r="8" fill="#d8b4ff"/>' +
      '<circle cx="32" cy="32" r="30" fill="url(#' + gid + ')"/>' +
      '</svg>'
    );
  }

  /* ---------- Flight path: always inside the viewport ---------- */

  var FLY_PAD = 14; // keeps the fly thumb + its glow off the screen edges

  function viewportSize() {
    var de = document.documentElement;
    var vv = window.visualViewport;
    var w = (de && de.clientWidth) || window.innerWidth || 0;
    var h = (de && de.clientHeight) || window.innerHeight || 0;
    if (vv && vv.width && vv.height && vv.scale && Math.abs(vv.scale - 1) < 0.01) {
      w = Math.min(w, vv.width);
      h = Math.min(h, vv.height);
    }
    return { w: w, h: h };
  }

  function rectFullyVisible(r, vp) {
    return !!r && r.width > 0 && r.height > 0 && r.top >= 0 && r.left >= 0 && r.bottom <= vp.h && r.right <= vp.w;
  }

  function clampCenter(v, half, max) {
    var lo = FLY_PAD + half;
    var hi = max - FLY_PAD - half;
    if (hi < lo) return max / 2;
    return Math.min(hi, Math.max(lo, v));
  }

  var floatReleaseTimer = 0;

  /* Pick a cart target that is actually on screen. If the header cart has
     scrolled away and the floating pill isn't showing yet, force the pill on
     (top-right, fixed) so the thumbnail always lands somewhere visible. */
  function flyTarget() {
    var vp = viewportSize();
    var floating = document.getElementById('wz-float-cart');
    if (floating && floating.classList.contains('is-visible')) return floating;
    var header = headerCartIcon();
    if (header && header.getBoundingClientRect && rectFullyVisible(header.getBoundingClientRect(), vp)) return header;
    floating = ensureFloatCart();
    floating.classList.add('is-forced', 'is-visible');
    return floating;
  }

  function releaseForcedFloat() {
    var el = document.getElementById('wz-float-cart');
    if (!el || !el.classList.contains('is-forced')) return;
    window.clearTimeout(floatReleaseTimer);
    floatReleaseTimer = window.setTimeout(function () {
      el.classList.remove('is-forced');
      floatCartVisibility();
    }, 1600);
  }

  /* Resolve the image URL that should fly into the cart.
     Priority:
       1) Variant featured_image / featured_media for the variant being added
       2) data-wz-image on the quick-add button (set when a variant is selected)
       3) FIRST product photo on the listing/card (never a secondary/hover gallery img)
       4) null -> branded purple orb fallback */
  function variantImageSrc(variant) {
    if (!variant) return null;
    var fi = variant.featured_image;
    if (typeof fi === 'string' && fi) return fi;
    if (fi && fi.src) return fi.src;
    if (variant.image) {
      if (typeof variant.image === 'string') return variant.image;
      if (variant.image.src) return variant.image.src;
    }
    var fm = variant.featured_media;
    if (fm && fm.preview_image && fm.preview_image.src) return fm.preview_image.src;
    return null;
  }

  function productFirstImageSrc(product) {
    if (!product) return null;
    var fi = product.featured_image;
    if (typeof fi === 'string' && fi) return fi;
    if (fi && fi.src) return fi.src;
    if (product.images && product.images.length) {
      var im = product.images[0];
      if (typeof im === 'string') return im;
      if (im && im.src) return im.src;
    }
    if (product.media && product.media.length) {
      for (var i = 0; i < product.media.length; i++) {
        var m = product.media[i];
        if (m && m.preview_image && m.preview_image.src) return m.preview_image.src;
        if (m && m.src) return m.src;
      }
    }
    return null;
  }

  function findCardScope(el) {
    if (!el || !el.closest) return el || null;
    return (
      el.closest(
        '.wzr-pcard, .card-wrapper, .product-card-wrapper, .wzr-rot__body, .wzr-rotator, [data-wzr-rotator], .wz-card-quick-host, .product, product-info, .product-main, .product__media-wrapper'
      ) || el
    );
  }

  /* First meaningful product photo in a card/PDP scope — prefers primary media, skips icons. */
  function firstProductImg(scope) {
    if (!scope) return null;
    if (scope.tagName === 'IMG') return scope;
    if (!scope.querySelector) return null;
    var mediaHost =
      scope.querySelector('.card__media') ||
      scope.querySelector('.wzr-pcard__media') ||
      scope.querySelector('.wzr-rot__slide.is-active .wzr-rot__media') ||
      scope.querySelector('.wzr-rot__slide.is-active') ||
      scope.querySelector('.product__media-item.is-active, .product__media-item[aria-hidden="false"]') ||
      scope.querySelector('.product__media') ||
      null;
    var preferred = null;
    if (mediaHost) {
      preferred =
        mediaHost.querySelector('img.product-card__image') ||
        mediaHost.querySelector('img');
    }
    if (!preferred) {
      preferred =
        scope.querySelector('img.product-card__image') ||
        scope.querySelector('.card__media img') ||
        scope.querySelector('.wzr-pcard__media img') ||
        scope.querySelector('.wzr-rot__slide.is-active img') ||
        scope.querySelector('.product__media-item.is-active img, .product__media img');
    }
    if (preferred) return preferred;
    var imgs = scope.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest('.wz-card-quick, .wz-toast, .wz-float-cart, button, .wz-empty-cart, .wz-empty-modal')) continue;
      var src = img.currentSrc || img.getAttribute('src') || '';
      if (!src || /icon|logo|spacer|pixel|1x1|data:image\/gif/i.test(src)) continue;
      var w = img.naturalWidth || img.width || parseInt(img.getAttribute('width'), 10) || 0;
      var h = img.naturalHeight || img.height || parseInt(img.getAttribute('height'), 10) || 0;
      if ((w && w < 40) || (h && h < 40)) continue;
      return img;
    }
    return null;
  }

  /* Absolute URL + small CDN width so the fly thumb loads fast on mobile. */
  function flyThumbUrl(src) {
    if (!src) return null;
    var s = String(src).trim();
    if (!s || s.indexOf('data:image/gif') === 0 || /spacer|pixel|1x1|blank\.gif/i.test(s)) return null;
    if (s.indexOf('//') === 0) s = (window.location.protocol || 'https:') + s;
    else if (s.charAt(0) === '/' && s.indexOf('//') !== 0) s = window.location.origin + s;
    // Prefer a modest width for the ~40–80px thumb (faster first paint on cellular)
    if (/cdn\.shopify\.com|\/cdn\/shop\//i.test(s) && !/[?&]width=\d+/.test(s)) {
      s = s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=160';
    } else if (/[?&]width=\d+/.test(s)) {
      s = s.replace(/([?&])width=\d+/i, '$1width=160');
    }
    return s;
  }

  function firstFromSrcset(ss) {
    if (!ss) return null;
    var best = null;
    var bestW = 0;
    String(ss)
      .split(',')
      .forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        if (!bits[0]) return;
        var w = 0;
        if (bits[1] && /w$/i.test(bits[1])) w = parseInt(bits[1], 10) || 0;
        // Prefer ~160–360w when available; otherwise take the first / largest reasonable
        if (!best) best = bits[0];
        if (w >= 120 && w <= 400 && (bestW < 120 || w < bestW || bestW > 400)) {
          best = bits[0];
          bestW = w;
        } else if (!bestW && w > bestW) {
          best = bits[0];
          bestW = w;
        }
      });
    return best;
  }

  function isPlaceholderSrc(s) {
    if (!s) return true;
    if (s.indexOf('data:image/gif') === 0 || s.indexOf('data:image/svg') === 0) return true;
    return /spacer|pixel|1x1|blank\.gif|placeholder|lqip/i.test(s);
  }

  /* Pull a usable product photo URL from a card <img>, including lazy-load attrs. */
  function pickImgUrl(img) {
    if (!img) return null;
    var cands = [
      img.currentSrc,
      img.getAttribute('src'),
      img.getAttribute('data-src'),
      img.getAttribute('data-original'),
      img.getAttribute('data-lazy-src'),
      firstFromSrcset(img.getAttribute('srcset')),
      firstFromSrcset(img.getAttribute('data-srcset')),
      firstFromSrcset(img.getAttribute('data-lazy-srcset'))
    ];
    for (var i = 0; i < cands.length; i++) {
      var u = flyThumbUrl(cands[i]);
      if (u && !isPlaceholderSrc(u)) return u;
    }
    return null;
  }

  var _wzWarm = Object.create(null);
  function warmFlyImage(src) {
    var u = flyThumbUrl(src);
    if (!u || _wzWarm[u]) return;
    _wzWarm[u] = true;
    try {
      var im = new Image();
      im.decoding = 'async';
      im.src = u;
    } catch (err) {}
  }

  /* Wait until the fly thumb has pixels (or timeout). Avoids blank first flight on mobile. */
  function waitFlyImage(img, ms) {
    return new Promise(function (resolve) {
      if (!img) {
        resolve(false);
        return;
      }
      var done = false;
      function finish(ok) {
        if (done) return;
        done = true;
        resolve(!!ok);
      }
      if (img.complete && img.naturalWidth > 0) {
        finish(true);
        return;
      }
      var t = window.setTimeout(function () {
        finish(img.naturalWidth > 0);
      }, ms || 220);
      function ok() {
        window.clearTimeout(t);
        finish(true);
      }
      function bad() {
        window.clearTimeout(t);
        finish(false);
      }
      img.addEventListener('load', ok, { once: true });
      img.addEventListener('error', bad, { once: true });
      if (typeof img.decode === 'function') {
        img.decode().then(ok).catch(function () {});
      }
    });
  }

  function resolveFlyImageSrc(fromEl, variantId) {
    var scope = findCardScope(fromEl);
    var vid = variantId != null ? String(variantId) : '';

    // Variant selected on the quick-add row
    var row =
      (fromEl && fromEl.closest && fromEl.closest('.wz-card-quick')) ||
      (scope && scope.querySelector && scope.querySelector('.wz-card-quick')) ||
      null;
    if (row && row._wzVariant) {
      var v = row._wzVariant.variant;
      if (vid && row._wzVariant.product && row._wzVariant.product.variants) {
        var vs = row._wzVariant.product.variants;
        for (var i = 0; i < vs.length; i++) {
          if (String(vs[i].id) === vid) {
            v = vs[i];
            break;
          }
        }
      }
      var vSrc = flyThumbUrl(variantImageSrc(v));
      if (vSrc) return vSrc;
      // Variant has no own image — use first product image from the product JSON
      var pSrc = flyThumbUrl(productFirstImageSrc(row._wzVariant.product));
      if (pSrc) return pSrc;
    }

    // Button data-wz-image (set in applyVariant / injectQuickAdd)
    var btn =
      (fromEl && fromEl.getAttribute && fromEl.getAttribute('data-wzr-quick-add') != null ? fromEl : null) ||
      (scope && scope.querySelector && scope.querySelector('[data-wzr-quick-add]')) ||
      null;
    if (btn) {
      var d = flyThumbUrl(btn.getAttribute('data-wz-image'));
      if (d) return d;
    }

    // FIRST product photo on the card / PDP (primary media only) — includes lazy data-src / srcset
    var img = firstProductImg(scope) || firstProductImg(fromEl);
    var fromDom = pickImgUrl(img);
    if (fromDom) return fromDom;
    return null;
  }

  /* ---------- First-add fly image (v3) ----------
     The first add used to fly an orb/blank box: the thumb URL (width=160) was a NEW, uncached
     request that only started after the cart POST returned, and the 240ms+180ms waits ran out.
     Now: (1) image loading starts on pointerdown / click, in parallel with the cart POST;
     (2) the photo already painted on the page (currentSrc, exact URL = browser cache) is preferred;
     (3) the flight waits for real pixels (generous timeout) and stays invisible until then. */
  var _wzKeep = [];
  function imgFileKey(u) {
    if (!u) return '';
    var path = String(u).split('#')[0].split('?')[0];
    var f = path.split('/').pop() || '';
    return f.replace(/_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.)/i, '').toLowerCase();
  }
  function loadedPageImg(fromEl) {
    var cands = [firstProductImg(findCardScope(fromEl)), firstProductImg(fromEl)];
    for (var i = 0; i < cands.length; i++) {
      var img = cands[i];
      if (img && img.complete && img.naturalWidth > 0 && (img.currentSrc || img.src) && !isPlaceholderSrc(img.currentSrc || img.src)) return img;
    }
    return null;
  }
  function flyCandidates(fromEl, variantId) {
    var list = [];
    function add(u) { if (u && !isPlaceholderSrc(u) && list.indexOf(u) === -1) list.push(u); }
    var want = null;
    try { want = resolveFlyImageSrc(fromEl, variantId); } catch (err) { want = null; }
    var pg = loadedPageImg(fromEl);
    var pgSrc = pg ? (pg.currentSrc || pg.src) : null;
    // Same photo already on screen -> reuse its exact URL (instant, from cache)
    if (pgSrc && (!want || imgFileKey(pgSrc) === imgFileKey(want))) add(pgSrc);
    add(want);
    if (want) add(String(want).replace(/([?&])width=\d+/i, '$1width=400'));
    add(pgSrc); // last resort: the card/slide photo the shopper is looking at
    return list;
  }
  function loadOne(src) {
    return new Promise(function (resolve) {
      var im = new Image();
      _wzKeep.push(im);
      if (_wzKeep.length > 24) _wzKeep.shift();
      var settled = false;
      function done(ok) {
        if (settled) return;
        settled = true;
        resolve(ok ? src : null);
      }
      im.onload = function () { done(im.naturalWidth > 0); };
      im.onerror = function () { done(false); };
      im.decoding = 'async';
      im.src = src;
      if (im.complete && im.naturalWidth > 0) { done(true); return; }
      if (typeof im.decode === 'function') im.decode().then(function () { done(true); }).catch(function () {});
    });
  }
  /* Start loading NOW. Resolves with the first candidate URL that has pixels (null if none). */
  function primeFly(fromEl, variantId) {
    if (reduceMotion) return Promise.resolve(null);
    var list = flyCandidates(fromEl, variantId);
    if (!list.length) return Promise.resolve(null);
    // Kick off all candidates in parallel; resolve in priority order
    var loads = list.map(loadOne);
    return loads.reduce(function (acc, p) {
      return acc.then(function (got) { return got || p; });
    }, Promise.resolve(null));
  }
  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (r) { window.setTimeout(function () { r(null); }, ms); })]);
  }

  function createFlyElement(fromEl, variantId, readySrc) {
    var el = document.createElement('div');
    el.className = 'wz-pokeball wz-pokeball--fly wz-fly-thumb wz-fly-thumb--pack';
    el.setAttribute('aria-hidden', 'true');
    var src = readySrc;
    if (src) {
      var img = new Image();
      img.className = 'wz-fly-thumb__img';
      img.alt = '';
      img.draggable = false;
      img.decoding = 'sync';
      img.src = src;
      el.appendChild(img);
      el._wzFlyImg = img;
    } else {
      el.classList.remove('wz-fly-thumb--pack');
      el.classList.add('wz-fly-thumb--orb');
      el.innerHTML = brandOrbSvg();
    }
    return el;
  }

  function flyToCart(fromEl, variantId, primed) {
    if (reduceMotion) return Promise.resolve(null);
    var cart = flyTarget();
    if (!cart) return Promise.resolve(null);

    // Start from the product photo/slide the shopper tapped
    var origin = fromEl && fromEl.getBoundingClientRect ? fromEl : cart;
    var from = origin.getBoundingClientRect();
    var vp0 = viewportSize();
    var ready = primed || primeFly(fromEl, variantId);

    // Wait for real pixels (loading began at tap time, in parallel with the cart POST)
    return withTimeout(ready, 1400).then(function (src) {
      if (!src) {
        // Still nothing: use whatever product photo is painted on screen right now
        var pg = loadedPageImg(fromEl);
        src = pg ? (pg.currentSrc || pg.src) : null;
      }
      var el = createFlyElement(fromEl, variantId, src);
      var isOrb = el.classList.contains('wz-fly-thumb--orb');
      var flyImg = el._wzFlyImg;

      var size = 40;
      size = Math.min(size, Math.max(28, Math.min(vp0.w, vp0.h) - FLY_PAD * 2));
      var half = size / 2;
      var END_SCALE = 0.42;

      // Start = centre of the source element, clamped (handles half-scrolled images)
      var sx = clampCenter(from.left + from.width / 2, half, vp0.w);
      var sy = clampCenter(from.top + from.height / 2, half, vp0.h);

      function targetCenter(vp) {
        var to = cart.getBoundingClientRect();
        var r = (size * END_SCALE) / 2;
        return {
          x: clampCenter(to.left + to.width / 2, r, vp.w),
          y: clampCenter(to.top + to.height / 2, r, vp.h)
        };
      }

      var end0 = targetCenter(vp0);
      // Arc control point: lifted above the higher of start/end, but never above the top edge
      var mx = clampCenter((sx + end0.x) / 2, half, vp0.w);
      var my = clampCenter(Math.min(sy, end0.y) - Math.max(80, Math.abs(end0.x - sx) * 0.28), half, vp0.h);

      el.style.width = size + 'px';
      el.style.height = size + 'px';
      el.style.left = '0';
      el.style.top = '0';
      el.style.transform = 'translate(' + (sx - half) + 'px,' + (sy - half) + 'px) scale(1) rotate(0deg)';
      // Invisible until the photo has pixels: the first frame is never an empty box
      if (flyImg) el.style.opacity = '0';
      document.body.appendChild(el);
      void el.offsetWidth;

      function runFlight() {
        el.style.opacity = '1';
        return new Promise(function (resolve) {
          var t0 = performance.now();
          function frame(now) {
            var t = Math.min(1, (now - t0) / FLY_MS);
            var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            var u = 1 - e;
            var vp = viewportSize();
            var end = targetCenter(vp); // live: follows the cart if the page scrolls mid-flight
            var scale = 1 - e * (1 - END_SCALE);
            var r = half * scale;
            var cx = u * u * sx + 2 * u * e * mx + e * e * end.x;
            var cy = u * u * sy + 2 * u * e * my + e * e * end.y;
            // Hard clamp every frame so no part of the thumb ever leaves the viewport
            cx = clampCenter(cx, r, vp.w);
            cy = clampCenter(cy, r, vp.h);
            // Mild tilt for product thumbs; orb can spin a bit more
            var rot = isOrb ? e * 360 : e * 18;
            var opacity = e > 0.85 ? 1 - (e - 0.85) / 0.15 : 1;
            el.style.transform =
              'translate(' + (cx - half).toFixed(1) + 'px,' + (cy - half).toFixed(1) + 'px) scale(' +
              scale.toFixed(3) + ') rotate(' + rot.toFixed(1) + 'deg)';
            el.style.opacity = String(opacity);
            if (t < 1) {
              requestAnimationFrame(frame);
            } else {
              el.remove();
              resolve(cart);
            }
          }
          requestAnimationFrame(frame);
        });
      }

      if (!flyImg) return runFlight();
      // src is already loaded (same URL = memory cache), so this is normally instant
      return waitFlyImage(flyImg, 600).then(function (ok) {
        if (!ok && flyImg.naturalWidth < 1) {
          el.classList.remove('wz-fly-thumb--pack');
          el.classList.add('wz-fly-thumb--orb');
          el.innerHTML = brandOrbSvg();
          isOrb = true;
        }
        return runFlight();
      });
    });
  }

  /* Warm the fly photo as soon as a finger/mouse goes down on an Add button (before click). */
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (reduceMotion || !e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-wzr-quick-add], .wzr-fly-add [type="submit"], form[data-wzr-fly-add] [type="submit"], .wzr-rot__form [type="submit"]');
      if (!btn) return;
      try {
        var form = btn.closest('form');
        var fromEl = form && isFlyFormLoose(form) ? findImageSource(form) : (btn.closest('.wzr-pcard, .card-wrapper, .product-card-wrapper, .wzr-rot__body, .wz-card-quick-host') || btn);
        if (fromEl && fromEl.querySelector && !form) fromEl = fromEl.querySelector('.wzr-pcard__media, .wzr-rot__media, .card__media, img') || fromEl;
        btn._wzPrimed = { t: Date.now(), p: primeFly(fromEl, btn.getAttribute('data-variant-id')) };
      } catch (err) {}
    },
    true
  );
  function isFlyFormLoose(form) {
    return !!(form && form.matches && form.matches('[data-wzr-fly-add], .wzr-fly-add, .wzr-rot__form'));
  }

  /* ---------- Toast (dark purple pop-up) ---------- */

  var TOAST_MS = 3200;
  var toastTimer = 0;

  function ensureToastRegion() {
    var region = document.getElementById('wz-toast-region');
    if (region) return region;
    region = document.createElement('div');
    region.id = 'wz-toast-region';
    region.className = 'wz-toast-region';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
    return region;
  }

  function hideToast() {
    var region = document.getElementById('wz-toast-region');
    var t = region && region.querySelector('.wz-toast');
    if (!t) return;
    t.classList.remove('is-in');
    t.classList.add('is-out');
    window.setTimeout(function () {
      if (t.parentNode) t.parentNode.removeChild(t);
    }, 260);
  }

  function showToast(title, body, kind) {
    var region = ensureToastRegion();
    window.clearTimeout(toastTimer);
    var t = region.querySelector('.wz-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'wz-toast';
      t.innerHTML =
        '<span class="wz-toast__icon" aria-hidden="true">' + cartPlusIconTiny() + '</span>' +
        '<span class="wz-toast__text"><strong class="wz-toast__title"></strong><span class="wz-toast__body"></span></span>' +
        '<button type="button" class="wz-toast__close" aria-label="Dismiss">&times;</button>';
      t.querySelector('.wz-toast__close').addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        window.clearTimeout(toastTimer);
        hideToast();
      });
      region.appendChild(t);
    }
    t.classList.remove('is-out', 'is-error', 'is-max', 'is-shake');
    t.classList.add(kind === 'error' ? 'is-error' : 'is-max');
    t.querySelector('.wz-toast__title').textContent = title || '';
    var b = t.querySelector('.wz-toast__body');
    b.textContent = body || '';
    b.hidden = !body;
    void t.offsetWidth;
    if (t.classList.contains('is-in')) t.classList.add('is-shake'); // repeat tap: nudge, don't stack
    t.classList.add('is-in');
    toastTimer = window.setTimeout(hideToast, TOAST_MS);
  }

  var MAX_TITLE = 'Maximum quantity reached';

  function showMaxToast(body) {
    showToast(MAX_TITLE, body || "You've hit the limit for this item.", 'max');
  }

  /* ---------- Max quantity detection ---------- */

  var cartLines = Object.create(null); // variantId -> qty currently in cart
  var cartLinesLoaded = false;

  function setCartLines(cart) {
    if (!cart || !cart.items) return;
    var map = Object.create(null);
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var vid = String(it.variant_id || it.id);
      map[vid] = (map[vid] || 0) + (parseInt(it.quantity, 10) || 0);
    }
    cartLines = map;
    cartLinesLoaded = true;
    refreshAllSteppers();
  }

  function refreshCartLines() {
    return fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setCartLines(cart); return cart; })
      .catch(function () { return null; });
  }

  function inCartQty(variantId) {
    return cartLines[String(variantId)] || 0;
  }

  function numAttr(el, names) {
    if (!el || !el.getAttribute) return null;
    for (var i = 0; i < names.length; i++) {
      var v = el.getAttribute(names[i]);
      if (v === null || v === '') continue;
      var n = parseInt(v, 10);
      if (isFinite(n)) return n;
    }
    return null;
  }

  var MAX_ATTRS = ['data-wz-max', 'data-max', 'data-max-qty', 'data-max-quantity', 'data-quantity-max'];
  var INV_ATTRS = ['data-wz-inventory', 'data-inventory', 'data-inventory-quantity', 'data-variant-inventory'];

  /* Cap for a variant's cart line (total allowed in cart), or null if unknown.
     Sources, smallest wins:
       - data-wz-max / data-max / data-max-qty / data-quantity-max on the input, row, form, or card
       - data-wz-inventory / data-inventory / data-inventory-quantity (only when tracked + deny)
       - quantity_rule.max and inventory_quantity from products/<handle>.js (stored on the row at inject)
       - a max="" attribute written into the qty input by the theme
       - a cap learned from a Shopify "All N … are in your cart" error */
  function lineCap(scope) {
    var caps = [];
    var nodes = [];
    var n = scope;
    for (var depth = 0; n && n.nodeType === 1 && depth < 6; depth++) {
      nodes.push(n);
      if (n.matches && n.matches('.card-wrapper, .product-card-wrapper, .wzr-pcard, .wzr-rot__body, form')) break;
      n = n.parentElement;
    }
    var input = scope.querySelector && scope.querySelector('[data-wzr-qty-input], input[name="quantity"]');
    if (input) nodes.unshift(input);
    for (var i = 0; i < nodes.length; i++) {
      var m = numAttr(nodes[i], MAX_ATTRS);
      if (m !== null && m >= 0) caps.push(m);
      var inv = numAttr(nodes[i], INV_ATTRS);
      var policy = nodes[i].getAttribute && (nodes[i].getAttribute('data-inventory-policy') || '');
      var mgmt = nodes[i].getAttribute && nodes[i].getAttribute('data-inventory-management');
      if (inv !== null && policy !== 'continue' && mgmt !== '' ) caps.push(Math.max(0, inv));
      var learned = numAttr(nodes[i], ['data-wz-learned-max']);
      if (learned !== null) caps.push(learned);
    }
    if (input && input.getAttribute('data-wz-theme-max')) {
      var tm = parseInt(input.getAttribute('data-wz-theme-max'), 10);
      if (isFinite(tm)) caps.push(tm);
    }
    if (!caps.length) return null;
    return Math.min.apply(Math, caps);
  }

  function variantIdFor(scope) {
    var b = scope.querySelector && scope.querySelector('[data-wzr-quick-add][data-variant-id]');
    if (b) return b.getAttribute('data-variant-id');
    var id = scope.querySelector && scope.querySelector('input[name="id"]');
    return id ? id.value : null;
  }

  /* How many more of this variant can still go into the cart (null = unknown). */
  function remainingFor(scope) {
    var cap = lineCap(scope);
    if (cap === null) return null;
    var vid = variantIdFor(scope);
    return Math.max(0, cap - (vid ? inCartQty(vid) : 0));
  }

  function maxCopy(remaining, scope) {
    var vid = variantIdFor(scope);
    var have = vid ? inCartQty(vid) : 0;
    if (remaining <= 0) {
      return have > 0 ? "You've already got the max in your cart." : 'This item is at its limit.';
    }
    if (have > 0) return 'Only ' + remaining + ' more can be added (' + have + ' in your cart).';
    return 'Only ' + remaining + ' available.';
  }

  function syncStepper(row) {
    if (!row) return;
    var input = row.querySelector('[data-wzr-qty-input]');
    var plus = row.querySelector('[data-wzr-qty="1"]');
    if (!input || !plus || input.disabled) return;
    var rem = remainingFor(row);
    var n = parseInt(input.value, 10);
    if (!isFinite(n) || n < 1) n = 1;
    if (rem === null) {
      input.removeAttribute('max');
      plus.classList.remove('is-max');
      plus.removeAttribute('aria-disabled');
      return;
    }
    if (rem >= 1) input.max = String(rem);
    else input.removeAttribute('max');
    if (rem >= 1 && n > rem) {
      n = rem;
      input.value = String(n);
    }
    var atMax = n >= rem;
    // Keep + clickable (not disabled) so tapping it at the max still shows the toast
    plus.classList.toggle('is-max', atMax);
    if (atMax) plus.setAttribute('aria-disabled', 'true');
    else plus.removeAttribute('aria-disabled');
  }

  function refreshAllSteppers() {
    var rows = document.querySelectorAll('.wz-card-quick');
    for (var i = 0; i < rows.length; i++) syncStepper(rows[i]);
  }

  /* Shopify cart/add.js returns 422 with messages like:
     "You can only add 3 Foo to the cart." / "All 2 Foo are in your cart." /
     "You can't add more Foo to the cart." / "The maximum quantity for this item is 4." */
  var MAX_ERR_RE = /(maximum|max(imum)? quantity|only add|can only|can['’]t add more|cannot add more|all \d+ .* in your cart|already in your cart|not enough|limit|exceed|quantity rule|increments? of)/i;

  function isMaxError(err) {
    if (!err) return false;
    var msg = String(err.message || '');
    if (MAX_ERR_RE.test(msg)) return true;
    return err.status === 422 && /quantity|stock|available|cart/i.test(msg);
  }

  function isSoldOutError(err) {
    return !!err && /sold out|out of stock|unavailable/i.test(String(err.message || ''));
  }

  function cleanShopifyMsg(msg) {
    var m = String(msg || '').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
    if (!m || m.length > 140) return '';
    return m;
  }

  /* After a max error, remember what we learned on the row/form so + and ADD respond instantly next time. */
  function learnFromMaxError(scope, err, attemptedQty) {
    if (!scope) return;
    var msg = String((err && err.message) || '');
    var host = (scope.matches && scope.matches('.wz-card-quick, form')) ? scope : scope.querySelector('.wz-card-quick, form') || scope;
    var all = msg.match(/all\s+(\d+)\b/i);
    if (all) host.setAttribute('data-wz-learned-max', all[1]);
    var input = scope.querySelector && scope.querySelector('[data-wzr-qty-input]');
    var only = msg.match(/only\s+(?:add\s+)?(\d+)\b/i) || msg.match(/maximum[^\d]*(\d+)/i);
    if (input && only) {
      var n = parseInt(only[1], 10);
      if (isFinite(n) && n >= 1 && (parseInt(input.value, 10) || 1) > n) input.value = String(n);
    } else if (input && attemptedQty > 1) {
      input.value = '1';
    }
  }

  function handleAddError(err, scope, attemptedQty) {
    if (isSoldOutError(err) && !isMaxError(err)) {
      showToast('Sold out', cleanShopifyMsg(err.message) || 'This item just sold out.', 'error');
      return true;
    }
    if (isMaxError(err)) {
      learnFromMaxError(scope, err, attemptedQty);
      showMaxToast(cleanShopifyMsg(err.message));
      refreshCartLines();
      return true;
    }
    return false;
  }

  function findImageSource(form) {
    var rotator = form.closest('[data-wzr-rotator]');
    if (rotator) {
      var slide =
        rotator.querySelector('.wzr-rot__slide.is-active .wzr-rot__media') ||
        rotator.querySelector('.wzr-rot__slide.is-active');
      if (slide) return slide;
    }
    var card = form.closest('.wzr-pcard, .card-wrapper, .product-card-wrapper, .card, .wz-card-quick-host');
    if (card) {
      var media =
        card.querySelector('.wzr-pcard__media') ||
        card.querySelector('.card__media') ||
        card.querySelector('img');
      if (media) return media;
    }
    var btn = form.querySelector('[type="submit"]');
    return btn || form;
  }

  function publishCartUpdate(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        window.publish(PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: 'wenzel-cart-fly' });
      }
    } catch (err) {}
  }

  function setLoading(form, on) {
    var btn = form.querySelector('[type="submit"], [data-wzr-quick-add]');
    if (!btn) return;
    if (on) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  function addVariant(variantId, quantity, fromEl) {
    var qty = quantity || 1;
    var id = parseInt(variantId, 10);
    if (!id) return Promise.reject(new Error('missing variant'));
    // Start loading the fly photo NOW, in parallel with the cart POST (first-add fix)
    var primed = primeFly(fromEl, id);

    return fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) {
          return r
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              var desc = body && body.description;
              if (desc && typeof desc === 'object') {
                try { desc = Object.keys(desc).map(function (k) { return desc[k]; }).join(' '); } catch (e2) { desc = ''; }
              }
              var msg = desc || (body && body.message) || 'Could not add to cart';
              var err = new Error(msg);
              err.status = r.status;
              throw err;
            });
        }
        return r.json();
      })
      .then(function () {
        return Promise.all([
          flyToCart(fromEl, id, primed),
          fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
            if (!r.ok) throw new Error('cart fetch failed');
            return r.json();
          })
        ]);
      })
      .then(function (results) {
        var cart = results[1];
        updateCartCount(cart.item_count);
        setCartLines(cart);
        if (!reduceMotion) bounceCart(results[0]);
        releaseForcedFloat();
        publishCartUpdate(cart);
        return cart;
      });
  }

  function isFlyForm(form) {
    if (!form || form.nodeType !== 1) return false;
    if (form.matches('[data-wzr-fly-add], .wzr-fly-add, .wzr-rot__form')) return true;
    return false;
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!isFlyForm(form)) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      if (form.hasAttribute('data-wzr-skip-fly')) return;

      e.preventDefault();
      e.stopPropagation();
      if (busy) return;
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var formRem = remainingFor(form);
      if (formRem !== null && qty > formRem) {
        showMaxToast(maxCopy(formRem, form));
        return;
      }
      busy = true;
      setLoading(form, true);
      var fromEl = findImageSource(form);

      addVariant(idInput.value, qty, fromEl)
        .catch(function (err) {
          console.warn('[wenzel-cart-fly]', err && err.message ? err.message : err);
          if (handleAddError(err, form, qty)) return;
          form.removeAttribute('data-wzr-fly-add');
          form.classList.remove('wzr-fly-add');
          if (typeof form.submit === 'function') form.submit();
        })
        .then(function () {
          busy = false;
          setLoading(form, false);
        });
    },
    true
  );

  function readQuickQty(btn) {
    var wrap = btn.closest('.wz-card-quick');
    var input = wrap && wrap.querySelector('[data-wzr-qty-input]');
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    if (!isFinite(n) || n < 1) n = 1;
    input.value = String(n);
    return n;
  }

  function bumpQuickQty(input, delta, row) {
    if (!input || input.disabled) return;
    var n = parseInt(input.value, 10);
    if (!isFinite(n) || n < 1) n = 1;
    if (delta > 0 && row) {
      var rem = remainingFor(row);
      if (rem !== null && n + delta > rem) {
        if (rem >= 1 && n > rem) input.value = String(rem);
        syncStepper(row);
        var plus = row.querySelector('[data-wzr-qty="1"]');
        if (plus) {
          plus.classList.remove('is-bump');
          void plus.offsetWidth;
          plus.classList.add('is-bump');
        }
        showMaxToast(maxCopy(rem, row));
        return;
      }
    }
    n = Math.max(1, n + delta);
    input.value = String(n);
    if (row) syncStepper(row);
  }

  document.addEventListener(
    'click',
    function (e) {
      var qtyBtn = e.target.closest('[data-wzr-qty]');
      if (qtyBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        var wrap = qtyBtn.closest('.wz-card-quick');
        var input = wrap && wrap.querySelector('[data-wzr-qty-input]');
        var delta = parseInt(qtyBtn.getAttribute('data-wzr-qty'), 10) || 0;
        bumpQuickQty(input, delta, wrap);
        return;
      }

      var btn = e.target.closest('[data-wzr-quick-add]');
      if (!btn) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (busy) return;
      var qty = readQuickQty(btn);
      var quickRow = btn.closest('.wz-card-quick') || btn.parentElement;
      var quickRem = remainingFor(quickRow);
      if (quickRem !== null && qty > quickRem) {
        syncStepper(quickRow);
        showMaxToast(maxCopy(quickRem, quickRow));
        return;
      }
      busy = true;
      btn.disabled = true;
      btn.classList.add('is-loading');
      var wrap =
        btn.closest('.wzr-pcard, .card-wrapper, .product-card-wrapper, .wzr-rot__body, .wz-card-quick-host') || btn;
      var from =
        wrap.querySelector('.wzr-pcard__media, .wzr-rot__media, .card__media, img') || wrap;
      addVariant(variantId, qty, from)
        .then(function () {
          var qi = quickRow && quickRow.querySelector('[data-wzr-qty-input]');
          if (qi) qi.value = '1';
        })
        .catch(function (err) {
          console.warn('[wenzel-cart-fly]', err && err.message ? err.message : err);
          if (!handleAddError(err, quickRow, qty)) {
            showToast("Couldn't add to cart", 'Please try again in a moment.', 'error');
          }
        })
        .then(function () {
          busy = false;
          btn.disabled = false;
          btn.classList.remove('is-loading');
          syncStepper(quickRow);
        });
    },
    true
  );

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-wzr-qty-input]');
    if (!input) return;
    var n = parseInt(input.value, 10);
    if (!isFinite(n) || n < 1) input.value = '1';
    var row = input.closest('.wz-card-quick');
    if (!row) return;
    var rem = remainingFor(row);
    if (rem !== null && (parseInt(input.value, 10) || 1) > rem) {
      input.value = String(Math.max(1, rem));
      showMaxToast(maxCopy(rem, row));
    }
    syncStepper(row);
  });

  /* ---------- Collection / search / catalog cards ---------- */

  function productHandleFromCard(card) {
    var a =
      card.querySelector('a.full-unstyled-link[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    try {
      var u = new URL(a.getAttribute('href'), window.location.origin);
      var parts = u.pathname.split('/').filter(Boolean);
      var i = parts.indexOf('products');
      if (i >= 0 && parts[i + 1]) return decodeURIComponent(parts[i + 1]);
    } catch (err) {}
    return null;
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    if (productCache[handle]) return productCache[handle];
    var url = routesRoot().replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    productCache[handle] = fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('product ' + handle);
        return r.json();
      })
      .catch(function (err) {
        delete productCache[handle];
        throw err;
      });
    return productCache[handle];
  }

  function pickVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var i;
    for (i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  /* Tiny cart+ icon for Add button / toast / empty-modal (brand purple, not a Poké Ball). */
  function cartPlusIconTiny() {
    return (
      '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
      '<path fill="none" stroke="#c084fc" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" ' +
      'd="M6 7h15l-1.4 8.4a2 2 0 0 1-2 1.6H9.2a2 2 0 0 1-2-1.55L5.2 4.5H3"/>' +
      '<circle cx="10" cy="20" r="1.35" fill="#c084fc"/>' +
      '<circle cx="17" cy="20" r="1.35" fill="#c084fc"/>' +
      '<path fill="none" stroke="#e9d5ff" stroke-width="1.8" stroke-linecap="round" d="M18.5 3.5v5M16 6h5"/>' +
      '</svg>'
    );
  }

  /* ---------- Multi-variant picker on quick add ----------
     Products with 2+ variants get a compact chooser above the stepper:
       - an option with <= 4 short values  -> pill buttons (e.g. NM / LP / MP, 1st Ed / Unlimited)
       - an option with more / longer values -> branded dropdown (native picker on phones)
     Defaults to the first available variant. Values with no in-stock variant are disabled ("Sold out").
     Picking a value swaps the Add button's variant id, the card price, the card image (variant image)
     and the max-qty cap, so qty stepper / product-thumb flight / max toast all follow the chosen version. */

  var PILL_MAX_VALUES = 4;
  var PILL_MAX_LABEL = 10;
  var vpickSeq = 0;

  function vOpt(v, i) {
    if (v.options && v.options.length > i) return v.options[i];
    return v['option' + (i + 1)];
  }

  function productOptions(product) {
    var opts = product.options || [];
    var out = [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var name = typeof o === 'string' ? o : (o && o.name) || 'Option ' + (i + 1);
      var values = o && o.values && o.values.length ? o.values.slice() : [];
      if (!values.length) {
        for (var k = 0; k < product.variants.length; k++) {
          var val = vOpt(product.variants[k], i);
          if (val != null && values.indexOf(val) === -1) values.push(val);
        }
      }
      out.push({ name: name, values: values });
    }
    return out;
  }

  function needsVariantPicker(product) {
    if (!product || !product.variants || product.variants.length < 2) return false;
    var opts = productOptions(product);
    for (var i = 0; i < opts.length; i++) if (opts[i].values.length > 1) return true;
    return false;
  }

  function variantMatches(v, sel, skip) {
    for (var j = 0; j < sel.length; j++) {
      if (j === skip || sel[j] == null) continue;
      if (vOpt(v, j) !== sel[j]) return false;
    }
    return true;
  }

  function findVariant(product, sel) {
    for (var i = 0; i < product.variants.length; i++) {
      if (variantMatches(product.variants[i], sel, -1)) return product.variants[i];
    }
    return null;
  }

  /* After option `changed` is set, pick the best real variant: in stock first,
     then the one that keeps the most of the shopper's other choices. */
  function bestVariantFor(product, sel, changed) {
    var best = null;
    var bestScore = -1;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (vOpt(v, changed) !== sel[changed]) continue;
      var score = v.available ? 100 : 0;
      for (var j = 0; j < sel.length; j++) if (j !== changed && vOpt(v, j) === sel[j]) score += 10 - j;
      if (score > bestScore) {
        best = v;
        bestScore = score;
      }
    }
    return best;
  }

  /* For value `val` of option i: anyAvail = some in-stock variant has it at all;
     availHere = in stock together with the shopper's other current choices. */
  function valueState(product, sel, i, val) {
    var anyAvail = false;
    var availHere = false;
    for (var k = 0; k < product.variants.length; k++) {
      var v = product.variants[k];
      if (vOpt(v, i) !== val || !v.available) continue;
      anyAvail = true;
      if (variantMatches(v, sel, i)) availHere = true;
    }
    return { anyAvail: anyAvail, availHere: availHere };
  }

  function usePills(opt) {
    if (opt.values.length > PILL_MAX_VALUES) return false;
    for (var i = 0; i < opt.values.length; i++) {
      if (String(opt.values[i]).length > PILL_MAX_LABEL) return false;
    }
    return true;
  }

  /* Money formatting that mirrors the card's own price text, e.g. "From $825.00 USD" -> "$950.00 USD". */
  function moneyFormatterFrom(sample) {
    var s = String(sample || '').replace(/\s+/g, ' ').trim().replace(/^from\s+/i, '');
    var m = s.match(/^([^\d]*)(\d[\d.,\u00a0 ]*\d|\d)(.*)$/);
    if (!m) return null;
    var num = m[2].replace(/[\u00a0 ]/g, '');
    var dec = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : '';
    var thou = dec === ',' ? '.' : ',';
    var pre = m[1];
    var post = (m[3].match(/^\s*[A-Za-z]{0,4}\.?/) || [''])[0]; // keep e.g. " USD", drop anything after
    return function (cents) {
      var n = (parseInt(cents, 10) || 0) / 100;
      var parts = (dec ? n.toFixed(2) : String(Math.round(n))).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return pre + parts[0] + (dec && parts[1] ? dec + parts[1] : '') + post;
    };
  }

  function cardPriceEl(card) {
    return card.querySelector('.card-information .price, .card__information .price, .price');
  }

  function cardMoneyFormatter(card) {
    var price = cardPriceEl(card);
    if (!price) return null;
    if (!price._wzFmt) {
      var sample = price.querySelector('.price__regular .price-item--regular, .price-item--sale, .price-item');
      price._wzFmt = moneyFormatterFrom((sample || price).textContent);
    }
    return price._wzFmt;
  }

  function updateCardPrice(card, variant) {
    var price = cardPriceEl(card);
    if (!price) return;
    var reg = price.querySelector('.price__regular .price-item--regular');
    var sale = price.querySelector('.price__sale .price-item--sale');
    var was = price.querySelector('.price__sale s.price-item--regular');
    var fmt = cardMoneyFormatter(card);
    if (!fmt) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var now = fmt(variant.price);
    if (reg) reg.textContent = onSale ? fmt(variant.compare_at_price) : now;
    if (sale) sale.textContent = now;
    if (was) was.textContent = onSale ? fmt(variant.compare_at_price) : '';
    price.classList.toggle('price--on-sale', !!onSale);
    price.classList.remove('price--sold-out');
  }

  function imgKey(src) {
    var s = String(src || '').split('?')[0];
    return s.substring(s.lastIndexOf('/') + 1).replace(/_\d+x\d*(?=\.)/, '');
  }

    function withWidth(src, w) {
    var base = String(src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function updateCardImage(card, variant) {
    var img = card.querySelector('.card__media img');
    if (!img) return;
    if (!img._wzOrig) {
      img._wzOrig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    }
    var src = variantImageSrc(variant);
    var targetKey = src ? imgKey(src) : imgKey(img._wzOrig.src);
    if (imgKey(img.getAttribute('src')) === targetKey) return;
    var nextSrc;
    var nextSrcset;
    if (src) {
      var widths = [];
      String(img._wzOrig.srcset || '').replace(/\s(\d+)w/g, function (_, w) { widths.push(parseInt(w, 10)); return _; });
      if (!widths.length) widths = [165, 360, 533, 720, 940];
      nextSrcset = widths.map(function (w) { return withWidth(src, w) + ' ' + w + 'w'; }).join(',');
      nextSrc = withWidth(src, 533);
    } else {
      nextSrc = img._wzOrig.src;
      nextSrcset = img._wzOrig.srcset;
    }
    img.classList.add('wz-vimg-swap');
    var done = function () {
      img.classList.remove('wz-vimg-swap');
      img.removeEventListener('load', done);
    };
    img.addEventListener('load', done);
    window.setTimeout(done, 600);
    if (nextSrcset) img.setAttribute('srcset', nextSrcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', nextSrc);
  }

  function variantCaps(variant) {
    var caps = [];
    var rule = variant.quantity_rule;
    if (rule && rule.max !== null && rule.max !== undefined && isFinite(parseInt(rule.max, 10))) {
      caps.push(parseInt(rule.max, 10));
    }
    if (
      typeof variant.inventory_quantity === 'number' &&
      variant.inventory_management === 'shopify' &&
      variant.inventory_policy !== 'continue'
    ) {
      caps.push(Math.max(0, variant.inventory_quantity));
    }
    return caps;
  }

  function setRowCap(row, variant) {
    var caps = variantCaps(variant);
    if (row._wzCardCap !== null && row._wzCardCap !== undefined) caps.push(row._wzCardCap);
    if (caps.length) row.setAttribute('data-wz-max', String(Math.min.apply(Math, caps)));
    else row.removeAttribute('data-wz-max');
  }

  function variantLabel(product, variant) {
    return variant.public_title || (variant.title && variant.title !== 'Default Title' ? variant.title : '') || product.title || '';
  }

  function renderPickerState(row) {
    var st = row._wzVariant;
    if (!st) return;
    var product = st.product;
    var sel = st.sel;
    var groups = row.querySelectorAll('[data-wz-opt]');
    for (var g = 0; g < groups.length; g++) {
      var grp = groups[g];
      var i = parseInt(grp.getAttribute('data-wz-opt'), 10);
      var select = grp.querySelector('select');
      if (select) {
        for (var o = 0; o < select.options.length; o++) {
          var opt = select.options[o];
          var s = valueState(product, sel, i, opt.value);
          opt.disabled = !s.anyAvail;
          opt.textContent = s.anyAvail ? opt.getAttribute('data-wz-base') : opt.value + ' \u2014 Sold out';
        }
        select.value = sel[i];
        var face = grp.querySelector('[data-wz-face-value]');
        if (face) face.textContent = sel[i];
        continue;
      }
      var pills = grp.querySelectorAll('[data-wz-opt-value]');
      for (var p = 0; p < pills.length; p++) {
        var pill = pills[p];
        var val = pill.getAttribute('data-wz-opt-value');
        var ps = valueState(product, sel, i, val);
        var active = val === sel[i];
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-checked', active ? 'true' : 'false');
        pill.tabIndex = active ? 0 : -1;
        pill.disabled = !ps.anyAvail;
        pill.classList.toggle('is-soldout', !ps.anyAvail);
        pill.classList.toggle('is-unavail', ps.anyAvail && !ps.availHere);
        pill.title = !ps.anyAvail ? val + ' \u2014 Sold out' : val;
      }
    }
  }

  function applyVariant(row, card, variant, opts) {
    var st = row._wzVariant;
    var btn = row.querySelector('[data-wzr-quick-add]');
    var input = row.querySelector('[data-wzr-qty-input]');
    if (!st || !btn) return;
    var prevId = btn.getAttribute('data-variant-id');
    // Keep a learned max (from Shopify errors) per variant, not per card
    if (prevId) {
      var learned = row.getAttribute('data-wz-learned-max');
      if (learned !== null) st.learned[prevId] = learned;
      else delete st.learned[prevId];
    }
    st.variant = variant;
    st.sel = [];
    for (var i = 0; i < st.options.length; i++) st.sel.push(vOpt(variant, i));
    var vid = String(variant.id);
    btn.setAttribute('data-variant-id', vid);
    var flySrc = variantImageSrc(variant) || productFirstImageSrc(st.product);
    if (flySrc) {
      btn.setAttribute('data-wz-image', flySrc);
      warmFlyImage(flySrc);
    } else btn.removeAttribute('data-wz-image');
    if (st.learned[vid] !== undefined) row.setAttribute('data-wz-learned-max', st.learned[vid]);
    else row.removeAttribute('data-wz-learned-max');
    row.setAttribute('data-wz-variant-title', variantLabel(st.product, variant));
    setRowCap(row, variant);

    var ok = !!variant.available;
    btn.disabled = !ok;
    btn.classList.toggle('is-soldout', !ok);
    if (ok) {
      btn.removeAttribute('aria-disabled');
      btn.innerHTML = cartPlusIconTiny() + '<span>Add to cart</span>';
      btn.setAttribute('aria-label', 'Add ' + variantLabel(st.product, variant) + ' to cart');
    } else {
      btn.setAttribute('aria-disabled', 'true');
      btn.innerHTML = '<span>Sold out</span>';
      btn.removeAttribute('aria-label');
    }
    var stepBtns = row.querySelectorAll('[data-wzr-qty]');
    for (var b = 0; b < stepBtns.length; b++) stepBtns[b].disabled = !ok;
    if (input) {
      input.disabled = !ok;
      if (!opts || !opts.keepQty) input.value = '1';
    }
    renderPickerState(row);
    updateCardPrice(card, variant);
    updateCardImage(card, variant);
    syncStepper(row);
  }

  function onPick(row, card, optIndex, value) {
    var st = row._wzVariant;
    if (!st || st.sel[optIndex] === value) return;
    var sel = st.sel.slice();
    sel[optIndex] = value;
    var v = findVariant(st.product, sel);
    if (!v || !v.available) v = bestVariantFor(st.product, sel, optIndex) || v;
    if (!v) return;
    applyVariant(row, card, v);
  }

  function caretSvg() {
    return (
      '<svg class="wz-vopt__caret" viewBox="0 0 12 8" width="10" height="7" aria-hidden="true" focusable="false">' +
      '<path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );
  }

  function stopCardNav(ev) {
    ev.stopPropagation();
  }

  function buildVariantPicker(row, card, product) {
    var options = productOptions(product);
    var wrap = document.createElement('div');
    wrap.className = 'wz-card-quick__variants';
    wrap.setAttribute('data-wz-variants', '');
    // Clicks inside the picker must never fall through to the card's product link
    wrap.addEventListener('click', stopCardNav);
    var uid = 'wzv' + ++vpickSeq;

    options.forEach(function (opt, i) {
      if (opt.values.length < 2) return; // nothing to choose (e.g. a single fixed option)
      var grp = document.createElement('div');
      grp.setAttribute('data-wz-opt', String(i));
      var labelId = uid + '-l' + i;
      if (usePills(opt)) {
        grp.className = 'wz-vopt wz-vopt--pills';
        grp.innerHTML = '<span class="wz-vopt__label" id="' + labelId + '"></span><div class="wz-vopt__pills" role="radiogroup"></div>';
        grp.querySelector('.wz-vopt__label').textContent = opt.name;
        var list = grp.querySelector('.wz-vopt__pills');
        list.setAttribute('aria-labelledby', labelId);
        opt.values.forEach(function (val) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'wz-vopt__pill';
          pill.setAttribute('role', 'radio');
          pill.setAttribute('data-wz-opt-value', val);
          pill.textContent = val;
          pill.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            if (pill.disabled) return;
            onPick(row, card, i, val);
          });
          list.appendChild(pill);
        });
        // Arrow keys move between pills (radiogroup pattern)
        list.addEventListener('keydown', function (ev) {
          var k = ev.key;
          if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'ArrowDown' && k !== 'ArrowUp') return;
          var pills = Array.prototype.filter.call(list.querySelectorAll('.wz-vopt__pill'), function (p) { return !p.disabled; });
          var cur = pills.indexOf(document.activeElement);
          if (cur < 0) return;
          ev.preventDefault();
          var next = pills[(cur + (k === 'ArrowRight' || k === 'ArrowDown' ? 1 : pills.length - 1)) % pills.length];
          next.focus();
          next.click();
        });
      } else {
        grp.className = 'wz-vopt wz-vopt--select';
        var selId = uid + '-s' + i;
        grp.innerHTML =
          '<label class="wz-vopt__label" for="' + selId + '"></label>' +
          '<div class="wz-vopt__field">' +
          '<select class="wz-vopt__select" id="' + selId + '"></select>' +
          '<span class="wz-vopt__face" aria-hidden="true"><span class="wz-vopt__face-value" data-wz-face-value></span>' + caretSvg() + '</span>' +
          '</div>';
        grp.querySelector('.wz-vopt__label').textContent = opt.name;
        var select = grp.querySelector('select');
        var showPrice = options.length === 1 && product.price_varies;
        var fmt = showPrice ? cardMoneyFormatter(card) : null;
        opt.values.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          var base = val;
          if (fmt) {
            var v = findVariant(product, [val]);
            if (v) base += ' \u2014 ' + fmt(v.price).replace(/\s+[A-Z]{3}$/, '');
          }
          o.setAttribute('data-wz-base', base);
          o.textContent = base;
          select.appendChild(o);
        });
        select.addEventListener('change', function (ev) {
          ev.stopPropagation();
          onPick(row, card, i, select.value);
        });
      }
      wrap.appendChild(grp);
    });
    return wrap.children.length ? wrap : null;
  }

  function injectQuickAdd(card, variant, available, product) {
    if (card.querySelector('[data-wzr-quick-add], .wz-card-quick')) return;
    var host =
      card.querySelector('.card-information') ||
      card.querySelector('.card__information') ||
      card.querySelector('.card__content');
    if (!host) return;

    var row = document.createElement('div');
    row.className = 'wz-card-quick';

    var stepper = document.createElement('div');
    stepper.className = 'wz-card-quick__stepper';
    stepper.setAttribute('data-wzr-qty-wrap', '');

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'wz-card-quick__qty-btn';
    minus.setAttribute('data-wzr-qty', '-1');
    minus.setAttribute('aria-label', 'Decrease quantity');
    minus.innerHTML = '<span aria-hidden="true">−</span>';

    var qty = document.createElement('input');
    qty.type = 'number';
    qty.className = 'wz-card-quick__qty';
    qty.name = 'quantity';
    qty.min = '1';
    qty.step = '1';
    qty.value = '1';
    qty.setAttribute('inputmode', 'numeric');
    qty.setAttribute('aria-label', 'Quantity');
    qty.setAttribute('data-wzr-qty-input', '');

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'wz-card-quick__qty-btn';
    plus.setAttribute('data-wzr-qty', '1');
    plus.setAttribute('aria-label', 'Increase quantity');
    plus.innerHTML = '<span aria-hidden="true">+</span>';

    if (!available) {
      minus.disabled = true;
      plus.disabled = true;
      qty.disabled = true;
    }

    stepper.appendChild(minus);
    stepper.appendChild(qty);
    stepper.appendChild(plus);
    row.appendChild(stepper);

    // Max-quantity data from products/<handle>.js (when Shopify exposes it) + any card-level data-max
    var cardCap = lineCap(card);
    row._wzCardCap = cardCap;
    setRowCap(row, variant);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wz-card-quick__btn';
    btn.setAttribute('data-wzr-quick-add', '');
    btn.setAttribute('data-variant-id', String(variant.id));
    var injectFlySrc = variantImageSrc(variant) || productFirstImageSrc(product);
    if (injectFlySrc) {
      btn.setAttribute('data-wz-image', injectFlySrc);
      warmFlyImage(injectFlySrc);
    }
    if (!available) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-soldout');
      btn.innerHTML = '<span>Sold out</span>';
    } else {
      btn.innerHTML = cartPlusIconTiny() + '<span>Add to cart</span>';
    }
    row.appendChild(btn);

    var price = host.querySelector('.price');
    if (price && price.parentNode === host) {
      price.insertAdjacentElement('afterend', row);
    } else {
      host.appendChild(row);
    }
    card.classList.add('wz-card-quick-host');

    // Multi-variant: option chooser above the stepper (only when something is actually buyable)
    if (available && needsVariantPicker(product)) {
      row._wzVariant = { product: product, options: productOptions(product), variant: variant, sel: [], learned: {} };
      var picker = buildVariantPicker(row, card, product);
      if (picker) {
        row.insertBefore(picker, row.firstChild);
        row.classList.add('wz-card-quick--variants');
        card.classList.add('wz-card-quick-host--variants');
        applyVariant(row, card, variant, { keepQty: true });
        return;
      }
      row._wzVariant = null;
    }
    syncStepper(row);
  }

  function enhanceCard(card) {
    if (!card || card.nodeType !== 1) return;
    if (card.getAttribute('data-wz-quick-ready') === '1') return;
    if (card.querySelector('[data-wzr-quick-add]')) {
      card.setAttribute('data-wz-quick-ready', '1');
      return;
    }
    var handle = productHandleFromCard(card);
    if (!handle) return;
    card.setAttribute('data-wz-quick-ready', '1');
    fetchProduct(handle)
      .then(function (product) {
        var v = pickVariant(product);
        if (!v) return;
        injectQuickAdd(card, v, !!v.available && product.available !== false, product);
      })
      .catch(function () {
        card.removeAttribute('data-wz-quick-ready');
      });
  }

  function enhanceAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll(
      '.card-wrapper.product-card-wrapper, .product-card-wrapper, li.grid__item .card-wrapper'
    );
    for (var i = 0; i < cards.length; i++) enhanceCard(cards[i]);
  }


  /* ---------- Floating cart (header stays non-sticky) ---------- */

  function ensureFloatCart() {
    var el = document.getElementById('wz-float-cart');
    if (el) return el;
    el = document.createElement('a');
    el.id = 'wz-float-cart';
    el.className = 'wz-float-cart';
    el.href = (routesRoot().replace(/\/?$/, '/') + 'cart');
    el.setAttribute('aria-label', 'Cart');
    el.innerHTML =
      '<span class="wz-float-cart__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" focusable="false">' +
      '<path d="M6 7h15l-1.4 8.4a2 2 0 0 1-2 1.6H9.2a2 2 0 0 1-2-1.55L5.2 4.5H3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<circle cx="10" cy="20" r="1.4" fill="currentColor"/>' +
      '<circle cx="17" cy="20" r="1.4" fill="currentColor"/>' +
      '</svg></span>' +
      '<span class="wz-float-cart__count" data-wz-float-count hidden>0</span>';
    document.body.appendChild(el);
    return el;
  }

  function syncFloatCount(n) {
    var el = ensureFloatCart();
    var badge = el.querySelector('[data-wz-float-count]');
    if (!badge) return;
    var count = parseInt(n, 10) || 0;
    if (count <= 0) {
      badge.hidden = true;
      badge.textContent = '0';
      el.classList.remove('has-items');
      return;
    }
    badge.hidden = false;
    badge.textContent = count < 100 ? String(count) : '99+';
    el.classList.add('has-items');
  }

  var _origUpdateCartCount = updateCartCount;
  updateCartCount = function (itemCount) {
    _origUpdateCartCount(itemCount);
    syncFloatCount(itemCount);
  };

  function floatCartVisibility() {
    var el = ensureFloatCart();
    var header = headerCartIcon();
    var show = false;
    if (header && header.getBoundingClientRect) {
      var r = header.getBoundingClientRect();
      // Show once header cart scrolls above the viewport (with small cushion)
      show = r.bottom < 8;
    } else {
      show = window.scrollY > 120;
    }
    if (el.classList.contains('is-forced')) show = true; // held on while a fly-to-cart thumb is landing
    el.classList.toggle('is-visible', !!show);
  }

  function bootFloatCart() {
    ensureFloatCart();
    floatCartVisibility();
    window.addEventListener('scroll', floatCartVisibility, { passive: true });
    window.addEventListener('resize', floatCartVisibility);
    // Seed count from header bubble or cart.js
    var header = headerCartIcon();
    var bubble = header && header.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (bubble && bubble.textContent) {
      var raw = bubble.textContent.trim();
      syncFloatCount(raw === '99+' ? 99 : parseInt(raw, 10) || 0);
    } else {
      fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) syncFloatCount(cart.item_count); })
        .catch(function () {});
    }
  }


  /* ---------- Empty cart (cart page + notification / drawer) ---------- */

  function clearCartUrl() {
    return routesRoot().replace(/\/?$/, '/') + 'cart/clear.js';
  }

  // Compact Empty cart control (top of cart page / drawer / notification header).
  // `where` = 'page' | 'drawer' | 'note' -> adds wz-empty-cart--{where}
  function makeEmptyCartButton(where) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wz-empty-cart wz-empty-cart--top' + (where ? ' wz-empty-cart--' + where : '');
    btn.setAttribute('data-wz-empty-cart', where || '1');
    btn.setAttribute('aria-label', 'Empty cart');
    btn.title = 'Remove all items from your cart';
    btn.innerHTML =
      '<svg class="wz-empty-cart__icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
      '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
      'd="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>' +
      '<span>Empty cart</span>';
    btn.addEventListener('click', onEmptyCartClick);
    return btn;
  }

  var emptying = false;
  var emptyModalOpen = false;
  var emptyModalPrevFocus = null;

  function ensureEmptyCartModal() {
    var root = document.getElementById('wz-empty-modal');
    if (root) return root;
    root = document.createElement('div');
    root.id = 'wz-empty-modal';
    root.className = 'wz-empty-modal';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="wz-empty-modal__backdrop" data-wz-empty-cancel tabindex="-1"></div>' +
      '<div class="wz-empty-modal__dialog" role="alertdialog" aria-modal="true" aria-labelledby="wz-empty-modal-title" aria-describedby="wz-empty-modal-desc">' +
      '<span class="wz-empty-modal__icon" aria-hidden="true">' + cartPlusIconTiny() + '</span>' +
      '<h2 id="wz-empty-modal-title" class="wz-empty-modal__title">Empty cart?</h2>' +
      '<p id="wz-empty-modal-desc" class="wz-empty-modal__body">Are you sure you want to empty your cart?</p>' +
      '<div class="wz-empty-modal__actions">' +
      '<button type="button" class="wz-empty-modal__btn wz-empty-modal__btn--cancel" data-wz-empty-cancel>Cancel</button>' +
      '<button type="button" class="wz-empty-modal__btn wz-empty-modal__btn--confirm" data-wz-empty-confirm>Empty cart</button>' +
      '</div></div>';
    document.body.appendChild(root);
    root.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-wz-empty-cancel]')) {
        ev.preventDefault();
        closeEmptyCartModal(false);
      } else if (ev.target.closest('[data-wz-empty-confirm]')) {
        ev.preventDefault();
        closeEmptyCartModal(true);
      }
    });
    return root;
  }

  function closeEmptyCartModal(confirmed) {
    var root = document.getElementById('wz-empty-modal');
    if (!root || !emptyModalOpen) return;
    emptyModalOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('hidden', '');
    document.body.classList.remove('wz-empty-modal-open');
    document.removeEventListener('keydown', onEmptyModalKeydown, true);
    var cb = root._wzEmptyResolve;
    root._wzEmptyResolve = null;
    var prev = emptyModalPrevFocus;
    emptyModalPrevFocus = null;
    if (prev && typeof prev.focus === 'function') {
      try { prev.focus(); } catch (err) {}
    }
    if (typeof cb === 'function') cb(!!confirmed);
  }

  function onEmptyModalKeydown(e) {
    if (!emptyModalOpen) return;
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      e.stopPropagation();
      closeEmptyCartModal(false);
      return;
    }
    if (e.key !== 'Tab' && e.keyCode !== 9) return;
    var root = document.getElementById('wz-empty-modal');
    if (!root) return;
    var focusables = root.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openEmptyCartModal() {
    return new Promise(function (resolve) {
      var root = ensureEmptyCartModal();
      if (emptyModalOpen) {
        resolve(false);
        return;
      }
      emptyModalOpen = true;
      emptyModalPrevFocus = document.activeElement;
      root._wzEmptyResolve = resolve;
      root.removeAttribute('hidden');
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.classList.add('wz-empty-modal-open');
      document.addEventListener('keydown', onEmptyModalKeydown, true);
      var confirmBtn = root.querySelector('[data-wz-empty-confirm]');
      var cancelBtn = root.querySelector('[data-wz-empty-cancel].wz-empty-modal__btn');
      window.setTimeout(function () {
        if (cancelBtn && typeof cancelBtn.focus === 'function') cancelBtn.focus();
        else if (confirmBtn && typeof confirmBtn.focus === 'function') confirmBtn.focus();
      }, 30);
    });
  }

  function performEmptyCart(btn) {
    emptying = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(clearCartUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('clear failed');
        return r.json().catch(function () {
          return { item_count: 0, items: [] };
        });
      })
      .then(function (cart) {
        var cleared = cart && typeof cart.item_count === 'number' ? cart : { item_count: 0, items: [] };
        updateCartCount(0);
        setCartLines({ items: [] });
        publishCartUpdate(cleared);
        var root = routesRoot().replace(/\/?$/, '/');
        var path = (location.pathname || '').replace(/\/+$/, '') || '/';
        if (path === '/cart' || /\/cart$/.test(path)) {
          location.assign(root + 'cart');
        } else {
          location.assign(root);
        }
      })
      .catch(function (err) {
        console.warn('[wenzel-empty-cart]', err && err.message ? err.message : err);
        emptying = false;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        showToast("Couldn't empty cart", 'Please try again in a moment.', 'error');
      });
  }

  function onEmptyCartClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    if (emptying || emptyModalOpen) return;
    var btn = e.currentTarget;
    openEmptyCartModal().then(function (ok) {
      if (ok) performEmptyCart(btn);
    });
  }

  function cartLooksEmpty(container) {
    if (!container) return false;
    if (container.classList && container.classList.contains('is-empty')) return true;
    if (container.closest && container.closest('.is-empty')) return true;
    var checkout =
      container.querySelector('#checkout, .cart__checkout-button, button[name="checkout"]') ||
      document.getElementById('checkout');
    if (checkout && checkout.disabled) return true;
    return false;
  }

  // Old placement (big pill under Check out / in wallet stack) — remove if present
  var LEGACY_EMPTY_HOSTS =
    '.cart__ctas [data-wz-empty-cart], .cart__dynamic-checkout-buttons [data-wz-empty-cart], ' +
    '.cart-notification__links [data-wz-empty-cart], .cart-drawer__footer [data-wz-empty-cart], ' +
    '.drawer__footer [data-wz-empty-cart], #main-cart-footer [data-wz-empty-cart]';

  function removeLegacyEmptyButtons() {
    var old = document.querySelectorAll(LEGACY_EMPTY_HOSTS);
    for (var i = 0; i < old.length; i++) {
      if (old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }
  }

  function ensureEmptyCartButtons() {
    removeLegacyEmptyButtons();

    // 1) Cart page: top-right of the "Your cart" title row (Dawn: cart-items > .title-wrapper-with-link)
    var titleRows = document.querySelectorAll(
      'cart-items .title-wrapper-with-link, #MainContent .cart-items-section .title-wrapper-with-link'
    );
    var placedPage = false;
    for (var i = 0; i < titleRows.length; i++) {
      var row = titleRows[i];
      placedPage = true;
      if (row.querySelector('[data-wz-empty-cart]')) continue;
      row.classList.add('wz-cart-title-row');
      var pbtn = makeEmptyCartButton('page');
      // Sit just before "Continue shopping" so the title stays left and controls group right
      var cont = row.querySelector('a.underlined-link, a[href*="/collections"]');
      if (cont && cont.parentNode === row) row.insertBefore(pbtn, cont);
      else row.appendChild(pbtn);
    }
    // Fallback: no title row — small toolbar above the line items (outside .js-contents, which Dawn re-renders)
    if (!placedPage) {
      var itemsWrap = document.getElementById('main-cart-items');
      if (itemsWrap && itemsWrap.parentNode && !document.querySelector('.wz-cart-toolbar [data-wz-empty-cart]')) {
        var bar = document.createElement('div');
        bar.className = 'wz-cart-toolbar';
        bar.appendChild(makeEmptyCartButton('page'));
        itemsWrap.parentNode.insertBefore(bar, itemsWrap);
      }
    }

    // 2) Cart drawer (if enabled): in the drawer header, left of the close X
    var drawerHeads = document.querySelectorAll('cart-drawer .drawer__header, #CartDrawer .drawer__header');
    for (var k = 0; k < drawerHeads.length; k++) {
      var head = drawerHeads[k];
      if (head.querySelector('[data-wz-empty-cart]')) continue;
      head.classList.add('wz-drawer-head');
      var dbtn = makeEmptyCartButton('drawer');
      var close = head.querySelector('.drawer__close, button[onclick*="close"], button[aria-label*="lose"]');
      if (close && close.parentNode === head) head.insertBefore(dbtn, close);
      else head.appendChild(dbtn);
    }

    // 3) Cart notification popup (after add-to-cart): in its header, left of the close X
    var noteHeads = document.querySelectorAll('cart-notification .cart-notification__header, #cart-notification .cart-notification__header');
    for (var j = 0; j < noteHeads.length; j++) {
      var nh = noteHeads[j];
      if (nh.querySelector('[data-wz-empty-cart]')) continue;
      nh.classList.add('wz-note-head');
      var nbtn = makeEmptyCartButton('note');
      var nclose = nh.querySelector('.cart-notification__close, button[aria-label*="lose"]');
      if (nclose && nclose.parentNode === nh) nh.insertBefore(nbtn, nclose);
      else nh.appendChild(nbtn);
    }

    syncEmptyCartVisibility();
  }

  function syncEmptyCartVisibility() {
    var buttons = document.querySelectorAll('[data-wz-empty-cart]');
    if (!buttons.length) return;

    var floatBadge = document.querySelector('[data-wz-float-count]');
    var floatCount = floatBadge && !floatBadge.hidden ? parseInt(floatBadge.textContent, 10) || 0 : 0;
    var header = headerCartIcon();
    var bubble = header && header.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    var bubbleCount = bubble ? parseInt((bubble.textContent || '').replace('+', ''), 10) || 0 : 0;
    var knownCount = Math.max(floatCount, bubbleCount);

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var host =
        btn.closest('.title-wrapper-with-link, .wz-cart-toolbar, cart-items, .drawer__header, cart-drawer, .cart-notification__header, cart-notification') ||
        btn.parentElement;
      var empty =
        cartLooksEmpty(host) ||
        cartLooksEmpty(document.getElementById('main-cart-footer')) ||
        cartLooksEmpty(document.querySelector('cart-items')) ||
        (knownCount === 0 &&
          !document.querySelector('cart-items:not(.is-empty) .cart-item, .cart-item, #cart-notification-product > *'));
      // If we positively know there are items, always show
      if (knownCount > 0) empty = false;
      // On cart page with line items visible, show
      if (document.querySelector('#main-cart-items .cart-item, cart-items:not(.is-empty) .cart-item')) {
        empty = false;
      }
      // Cart notification with a product shown
      var noteProduct = document.getElementById('cart-notification-product');
      if (noteProduct && noteProduct.children && noteProduct.children.length) empty = false;

      btn.hidden = !!empty;
      btn.style.display = empty ? 'none' : '';
      if (empty) btn.setAttribute('aria-hidden', 'true');
      else btn.removeAttribute('aria-hidden');
    }
  }

  function bootEmptyCart() {
    ensureEmptyCartButtons();
    syncEmptyCartVisibility();
    // Re-inject when cart notification / drawer markup updates
    document.addEventListener('cart:updated', syncEmptyCartVisibility);
    document.addEventListener('cart:refresh', function () {
      ensureEmptyCartButtons();
      syncEmptyCartVisibility();
    });
    if (typeof MutationObserver !== 'undefined') {
      var emptyQueued = false;
      var moEmpty = new MutationObserver(function () {
        if (emptyQueued) return;
        emptyQueued = true;
        var run = function () {
          emptyQueued = false;
          ensureEmptyCartButtons();
        };
        if (window.requestAnimationFrame) window.requestAnimationFrame(run);
        else setTimeout(run, 16);
      });
      moEmpty.observe(document.body, { childList: true, subtree: true });
    }
  }

  function boot() {
    bootFloatCart();
    bootEmptyCart();
    refreshCartLines();
    document.addEventListener('cart:updated', function (ev) {
      if (ev && ev.detail && ev.detail.items) setCartLines(ev.detail);
    });
    enhanceAll(document);
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.card-wrapper, .product-card-wrapper, li.grid__item')) {
              enhanceCard(n.matches('.card-wrapper, .product-card-wrapper') ? n : n.querySelector('.card-wrapper'));
            }
            if (n.querySelectorAll) enhanceAll(n);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* WZ_CARD_CLICK */
(function () {
  if (window.__wzCardClick) return;
  window.__wzCardClick = true;
  function productHref(card) {
    var a =
      card.querySelector('.card__heading a[href]') ||
      card.querySelector('a.full-unstyled-link[href]') ||
      card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : null;
  }
  function isInteractive(el) {
    if (!el || !el.closest) return false;
    return !!el.closest(
      'a, button, input, select, textarea, label, ' +
        '.wz-card-quick, [data-wzr-quick-add], quantity-input, ' +
        '.quantity, .product-form, form, .wz-toast, .price-per-item'
    );
  }
  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var card = e.target && e.target.closest && e.target.closest('.card-wrapper, .product-card-wrapper, .wzr-pcard');
      if (!card) return;
      if (isInteractive(e.target)) return;
      var href = productHref(card);
      if (!href) return;
      e.preventDefault();
      window.location.href = href;
    },
    false
  );
})();
